var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('language-toggle-link');
import { breakpoints, theme } from '@shapeable/theme';
import { ArrowRightIcon } from '@shapeable/icons';
import { usePlatformUrl } from '../hooks/use-platform-url';
import { Icon } from './icon';
import { useLink } from '../hooks/use-link';
export var PlatformLinkDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    text-transform: uppercase; \n    margin-top: ", ";\n    text-transform: uppercase;\n    \n    a {\n      color: ", ";\n      text-decoration: none;\n\n      &:hover {\n        color: ", ";\n      }\n    }\n  "], ["\n    font-size: ", ";\n    text-transform: uppercase; \n    margin-top: ", ";\n    text-transform: uppercase;\n    \n    a {\n      color: ", ";\n      text-decoration: none;\n\n      &:hover {\n        color: ", ";\n      }\n    }\n  "])), theme.FONT_SIZE(9), theme.UNIT(1), theme.COLOR('link'), theme.COLOR('link-hover')),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(11)),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(12))
});
var IconStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 14px;\n    height: 14px;\n    margin-right: ", ";\n\n    ", ";\n    &:hover {\n      ", ";\n    }\n\n  "], ["\n    width: 14px;\n    height: 14px;\n    margin-right: ", ";\n\n    ", ";\n    &:hover {\n      ", ";\n    }\n\n  "])), theme.UNIT(1.5), theme.FILL('link'), theme.FILL('link-hover'))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Icon: styled(Icon)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
export var PlatformLink = function (props) {
  var className = props.className,
    children = props.children;
  var platformUrl = usePlatformUrl();
  var url = props.url || platformUrl;
  var icon = props.icon || React.createElement(ArrowRightIcon, null);
  var Link = useLink().Link;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(Link, {
    target: "_blank",
    style: {
      display: "flex",
      alignItems: "center"
    },
    href: url
  }, React.createElement(My.Icon, null, icon), children || 'Login'));
};
PlatformLink.defaultProps = PlatformLinkDefaultProps;
PlatformLink.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;